import { getApprovals } from "@/services/approvals.service";
import { useQueries } from "@tanstack/react-query";

// There's no dedicated /approvals/stats endpoint, so this pieces the summary
// tiles together from the list endpoint (size=1 requests, we only need each
// response's totalCount).
export const useApprovalStats = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["approvalStats", "total"],
        queryFn: () => getApprovals({ page: 0, size: 1 }),
      },
      {
        queryKey: ["approvalStats", "pending"],
        queryFn: () => getApprovals({ page: 0, size: 1, status: "PENDING" }),
      },
      {
        queryKey: ["approvalStats", "approved"],
        queryFn: () => getApprovals({ page: 0, size: 1, status: "APPROVED" }),
      },
      {
        queryKey: ["approvalStats", "rejected"],
        queryFn: () => getApprovals({ page: 0, size: 1, status: "REJECTED" }),
      },
    ],
  });

  const [totalQuery, pendingQuery, approvedQuery, rejectedQuery] = results;

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.some((r) => r.isError);

  return {
    stats: {
      total: totalQuery.data?.totalCount ?? 0,
      pending: pendingQuery.data?.totalCount ?? 0,
      approved: approvedQuery.data?.totalCount ?? 0,
      rejected: rejectedQuery.data?.totalCount ?? 0,
    },
    isLoading,
    isError,
  };
};
